import React from 'react';
import { Checkbox } from '@homeexchange/design';
import i18n from '../../../../i18n';
import FeatureModels from '../../../../models/Feature';
import AmenitiesGroup from './amenitiesGroup';
export var Amenities = function (_a) {
    var filters = _a.filters, onFilterUpdate = _a.onFilterUpdate, onFilterMultipleUpdate = _a.onFilterMultipleUpdate;
    return (React.createElement(React.Fragment, null,
        FeatureModels.FEATURES_GROUPS.filter(function (group) {
            return group.type !== FeatureModels.AMENITIES_TYPE_RULE_FAVOR &&
                group.type !== FeatureModels.SURROUNDING_TYPE_TAGS &&
                group.type !== FeatureModels.AMENITIES_TYPE_ECO;
        }).map(function (group) { return (React.createElement(AmenitiesGroup, { key: group.type, title: i18n.t(group.title), features: group.features, amenities: filters === null || filters === void 0 ? void 0 : filters.amenities, onUpdate: onFilterMultipleUpdate })); }),
        FeatureModels.FEATURES_GROUPS.filter(function (group) { return group.type === FeatureModels.AMENITIES_TYPE_ECO; }).map(function (group) { return (React.createElement("div", { key: group.type },
            React.createElement("h4", null,
                React.createElement("i", { className: "icon icon-leaf" }),
                i18n.t(group.title)),
            React.createElement("div", null,
                React.createElement(Checkbox, { name: "eco_level", value: "4", checked: (filters === null || filters === void 0 ? void 0 : filters.eco_level) == FeatureModels.ECO_LEVEL, onChange: onFilterUpdate, label: i18n.t('home:feature-only-sustainable-homes'), message: i18n.t('home:only-sustainable-homes') })))); })));
};
export default Amenities;
